import { Reducer } from 'redux';
import { AutomaticChargeState, AutomaticChargeTypes } from './types';

const INITIAL_STATE: AutomaticChargeState = {
  statusData: {
    status: null,
    contractAcceptedAt: null,
    contractVersion: null,
    payoutAccount: null,
    paymentConfigReady: true,
  },
  statusLoaded: false,
  dailyReports: [],
  historyDetail: [],
  historyDetailTotalCount: 0,
  error: false,
  loading: false,
};

const reducer: Reducer<AutomaticChargeState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    // CASES GET STATUS
    case AutomaticChargeTypes.GET_AUTOMATIC_CHARGE_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        statusLoaded: false,
        statusData: INITIAL_STATE.statusData,
      };
    case AutomaticChargeTypes.GET_AUTOMATIC_CHARGE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        statusLoaded: true,
        statusData: action.payload.statusData,
      };
    case AutomaticChargeTypes.GET_AUTOMATIC_CHARGE_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        statusLoaded: false,
        statusData: INITIAL_STATE.statusData,
      };

    // CASES ACCEPT CONTRACT / ENABLE
    case AutomaticChargeTypes.ACCEPT_AUTOMATIC_CHARGE_CONTRACT_REQUEST:
    case AutomaticChargeTypes.ENABLE_AUTOMATIC_CHARGE_REQUEST:
    case AutomaticChargeTypes.UPDATE_AUTOMATIC_CHARGE_PAYOUT_ACCOUNT_REQUEST:
      return { ...state, loading: true, error: false };
    case AutomaticChargeTypes.ACCEPT_AUTOMATIC_CHARGE_CONTRACT_SUCCESS:
    case AutomaticChargeTypes.ENABLE_AUTOMATIC_CHARGE_SUCCESS:
    case AutomaticChargeTypes.UPDATE_AUTOMATIC_CHARGE_PAYOUT_ACCOUNT_SUCCESS:
      return { ...state, loading: false, error: false };
    case AutomaticChargeTypes.ACCEPT_AUTOMATIC_CHARGE_CONTRACT_FAILURE:
    case AutomaticChargeTypes.ENABLE_AUTOMATIC_CHARGE_FAILURE:
    case AutomaticChargeTypes.UPDATE_AUTOMATIC_CHARGE_PAYOUT_ACCOUNT_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES DAILY REPORT
    case AutomaticChargeTypes.GET_AUTOMATIC_CHARGE_DAILY_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        dailyReports: INITIAL_STATE.dailyReports,
      };
    case AutomaticChargeTypes.GET_AUTOMATIC_CHARGE_DAILY_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        dailyReports: action.payload.dailyReports,
      };
    case AutomaticChargeTypes.GET_AUTOMATIC_CHARGE_DAILY_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        dailyReports: INITIAL_STATE.dailyReports,
      };

    // CASES HISTORY DETAIL
    case AutomaticChargeTypes.GET_AUTOMATIC_CHARGE_HISTORY_DETAIL_REQUEST:
      return { ...state, loading: true, error: false };
    case AutomaticChargeTypes.GET_AUTOMATIC_CHARGE_HISTORY_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        historyDetail: action.payload.historyDetail,
        historyDetailTotalCount: action.payload.historyDetailTotalCount,
      };
    case AutomaticChargeTypes.GET_AUTOMATIC_CHARGE_HISTORY_DETAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        historyDetail: INITIAL_STATE.historyDetail,
        historyDetailTotalCount: INITIAL_STATE.historyDetailTotalCount,
      };

    default:
      return state;
  }
};

export default reducer;
